import { ImageBoss } from 'components/Content/Atoms/ImageBoss';
import { ImageCrop } from 'types/imageCrop';
import styles from './ImageGallery.module.scss';

interface ImageGalleryAtomProps {
  url: string;
  alt: string;
  width?: number;
  caption?: string;
  className?: string;
  imageCrop?: ImageCrop;
}
export function ImageGalleryAtom(props: ImageGalleryAtomProps) {
  const { url, alt, width, caption, className, imageCrop } = props;
  return (
    <>
      <ImageBoss url={url} alt={alt} width={width} className={className} imageCrop={imageCrop} />
      {caption && <div className={styles.imageSlideCaption}>{caption}</div>}
    </>
  );
}
